import { IDonationRate } from "@/props/IDonation";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { useRef } from "react";

const EventHighlightsMobile = ({ isIB, tradingRate }: { isIB?: boolean; tradingRate: IDonationRate }) => {
  const { t } = useTranslation();
  const paginationRef = useRef<HTMLDivElement>(null);
  const highlights = [
    {
      imageUrl: "/images/csr/highlight_2.webp",
      width: 340,
      height: 268,
      title: t(`csr.highlights_tit2`),
      desc: t(`csr.highlights_desc2`),
    },
  ];

  if (isIB) {
    highlights.push({
      imageUrl: "/images/csr/highlight_3.webp",
      width: 416,
      height: 320,
      title: t(`csr.highlights_tit3`),
      desc: t(`csr.highlights_desc3`),
    });
    highlights.push({
      imageUrl: "/images/csr/highlight_1.webp",
      width: 416,
      height: 320,
      title: t(`csr.highlights_tit1`),
      desc: t(`csr.highlights_desc1`),
    });
  }

  return (
    <div className="bg-[#eff0f1] bg-cover bg-center">
      <div className="m-auto py-[40px]">
        <h1 className="mb-4 h-[48px] text-center text-2xl font-semibold">
          {t("csr.event")}
          <span className="ml-1 inline-block bg-yellow-600 p-2">{t("csr.execution_plan")}</span>
        </h1>

        <div className="flex flex-col items-center">
          <Swiper
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            loop={true}
            navigation={false}
            pagination={{
              el: paginationRef.current!,
              clickable: true,
            }}
            onBeforeInit={(swiper) => {
              if (swiper.params.pagination && typeof swiper.params.pagination !== "boolean") {
                swiper.params.pagination.el = paginationRef.current;
              }
            }}
            modules={[Navigation, Pagination, Autoplay]}
            className="my-swiper-csr"
            slidesPerView="auto"
            centeredSlides={true}
            spaceBetween={16}
            style={{
              width: "100%",
              paddingLeft: "16px",
              paddingRight: "16px",
            }}
          >
            {highlights.map((highlight, index) => (
              <SwiperSlide
                key={highlight.imageUrl || index}
                style={{ width: "340px", height: "440px" }}
                className="!h-auto"
              >
                <div className="flex flex-col gap-4 rounded-[32px] bg-white p-6 text-left" style={{ height: "405px" }}>
                  <Image
                    src={highlight.imageUrl}
                    width={highlight.width}
                    height={highlight.height}
                    className="rounded-md object-cover"
                    alt={`highlight_${index + 1}`}
                  />
                  <p className="text-lg font-semibold text-stone-800">{highlight.title}</p>
                  <p className="text-sm text-[#4c4c4c]">{highlight.desc}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div ref={paginationRef} className="mt-6 flex items-center justify-center" />
        </div>
      </div>
      <style jsx global>{`
        .swiper-pagination-bullet {
          width: 8px;
          height: 8px;
          background-color: white;
          opacity: 1;
          border-radius: 9999px;
          margin: 0 4px;
          transition: all 0.3s ease;
        }

        .swiper-pagination-bullet-active {
          width: 24px;
          background-color: #e60012;
        }
      `}</style>
    </div>
  );
};

export default EventHighlightsMobile;
